import Text from "@/components/ui/text";
import { Commercials, Period } from "@/pages/deals/types";
import React from "react";
import { useTranslation } from "react-i18next";
import IconContainer from "@/components/ui/icon-container";
import { Delete, Edit, LinkTo } from "@dreamhub/designsystem/icons";
import { formatNumber } from "@/utils/numbers";
import { getCurrentLocale } from "@/utils/locale";
import { cn } from "@/utils/utils";
import { IconButton } from "@/components/ui/icon-button";
import { map } from "lodash";

const TRANSLATION_PREFIX = "deals.commercials";

interface Props {
  data: Commercials | null;
  handleEditBreakdown: () => void;
  setIsDeleteBreakdownModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  contractCurrencySymbol: string;
  isReadOnly?: boolean;
}

const ExistingBreakdown: React.FC<Props> = ({
  data,
  handleEditBreakdown,
  setIsDeleteBreakdownModalOpen,
  contractCurrencySymbol,
  isReadOnly
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "group flex flex-col gap-1 rounded col-span-2 mb-3 transition-colors duration-200 ease-in-out",
        !isReadOnly && "cursor-pointer hover:bg-white-8"
      )}
      onClick={() => !isReadOnly && handleEditBreakdown()}
    >
      <div className="flex gap-6 p-1 pl-2 items-center">
        <div className="flex gap-2 items-center">
          <IconContainer color="secondary">
            <LinkTo />
          </IconContainer>
          <Text variant="bodySecondary">
            {t(`${TRANSLATION_PREFIX}.breakdownByMonth`)}
          </Text>
        </div>
        {!isReadOnly && (
          <div className="flex gap-2 items-center opacity-0 transition-opacity duration-200 ease-in-out group-hover:opacity-100">
            <IconButton
              iconColor="secondary"
              size="md"
              variant="iconNoBg"
              onClick={(e) => {
                e.stopPropagation();
                handleEditBreakdown();
              }}
            >
              <Edit />
            </IconButton>
            <IconButton
              iconColor="secondary"
              size="md"
              variant="iconNoBg"
              onClick={(e) => {
                e.stopPropagation();
                setIsDeleteBreakdownModalOpen(true);
              }}
            >
              <Delete />
            </IconButton>
          </div>
        )}
      </div>
      <div className="flex flex-col gap-2 pl-6 pb-2 pr-2">
        {map(data?.amountBreakdownByPeriod?.periods, (period: Period) => {
          const { value: formattedValue } = formatNumber(
            period?.amount || 0,
            0,
            true,
            false,
            false,
            getCurrentLocale()
          );
          const periodAmount = `${contractCurrencySymbol}${formattedValue}`;
          return (
            <div className="flex gap-6" key={period.id}>
              <Text
                variant="bodySecondary"
                className="min-w-12"
              >{`${period?.startMonth} - ${period?.endMonth}`}</Text>
              <Text variant="bodySecondary">{periodAmount}</Text>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ExistingBreakdown;
